
<div class="graph-container">
  <app-percentage-of-new-patients-multilevel-chart
    [isSpecialty]="true"
    [isDepartment]="false"
    [level]="'By Specialty'"
    [barSelectionCallback]="whenBarSelected"
    [npvData]="newPatientVisits"
    [zeroSuppression]="zeroSuppression"
    [benchmarkType]="benchmarkType"
    [benchmarkOption]="benchmarkOption"
    [activeVarianceToggle]="activeVarianceToggle"
    [showProgressBar]="showProgressBar"
    page="npvSnapshot"
    [showExtendedBenchmarkOptions]="showExtendedBenchmarkOptions"
    [tieBreakerProperty]="tieBreakerProperty"
    [showVariableMenu]="true"
    [sortingCriteria]="activeVarianceToggle ? varianceToggleSortingCriterion : npvSortingCriteria"
    [varianceKey]="varianceKey"
    [variables]="variables">
  </app-percentage-of-new-patients-multilevel-chart>
</div>
<app-new-patient-visits-summary-data-table [showExtendedBenchmarkOptions]="showExtendedBenchmarkOptions"></app-new-patient-visits-summary-data-table>
<app-new-patient-visits-data-table id="npv-snapshot"
                [receivedData]="newPatientVisits"
                [updateSortingCriteria]="updateSortingCriteria"
                [columns]="displayedColumns"
                [whenSortChanged]="levelSpecificHandleSortChange"
                [defaultSortColumn]="defaultSortColumn"
                [sortDirection]="sortDirection"
                [sortingDataAccessor]="sortingDataAccessor"
                [tieBreakerProperty]="tieBreakerProperty"
                [rowSelectionCallback]="whenSpecialtySelected"
                [tableTitle]="'New Patients By Specialty'"
                [showLevel]="false"
                [showProgressBar]="showProgressBar"
                [displayZeroSuppression]=true
                [shouldPutNullsAtTheBottom]="activeVarianceToggle"
                [isZeroSuppressionChecked]="zeroSuppression"
                [countOfSuppressedEntries]="countOfSuppressedEntries"
                [zeroSuppressionCondition]="zeroSuppressionCondition"
                [currentPage]="currentPage"
                [originalColumns]="columns"
                [addRemoveOption]="true"
                [reducerAction]="snapshotNPVColumnsChangedTo" zeroSuppressionSnapshotEntry = "Specialties"
>
</app-new-patient-visits-data-table>
